/* @flow */

import moment from 'moment-timezone';

export function getTimezoneAbbreviation(timestamp: number): ?string {
    const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone; // eslint-disable-line babel/new-cap

    if (!timezoneName) {
        return null;
    }

    // This will silently error if moment does not
    // support the timezoneName from the browser (it should!)
    const timezoneAbbreviation = moment.unix(timestamp).tz(timezoneName);

    if (timezoneAbbreviation) {
        return timezoneAbbreviation.zoneAbbr();
    }

    return null;
}
